"use client"

import { BookUser } from "lucide-react"

export const TopClasses = ({ classes }) => {
    const hasClasses = Array.isArray(classes) && classes.length > 0
    const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || process.env.REACT_APP_BASE_URL

    return (
        <div
            style={{
                width: "100%",
                maxWidth: "100%",
                marginTop: "2rem",
                minHeight: "550px",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <h2
                style={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                    marginBottom: "1rem",
                    color: "#1f2937",
                    margin: "0 0 1rem 0",
                }}
            >
                Top 5 Classes
            </h2>

            {hasClasses ? (
                <div
                    style={{
                        overflowX: "auto",
                        backgroundColor: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: "12px",
                        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            height: "100%",
                        }}
                    >
                        <thead>
                            <tr
                                style={{
                                    backgroundColor: "#f8fafc",
                                    textAlign: "left",
                                    borderBottom: "2px solid #e2e8f0",
                                }}
                            >
                                <th
                                    style={{
                                        padding: "1rem",
                                        fontSize: "0.875rem",
                                        fontWeight: "600",
                                        color: "#374151",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                    }}
                                >
                                    Image
                                </th>
                                <th
                                    style={{
                                        padding: "1rem",
                                        fontSize: "0.875rem",
                                        fontWeight: "600",
                                        color: "#374151",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                    }}
                                >
                                    Title
                                </th>
                                <th
                                    style={{
                                        padding: "1rem",
                                        fontSize: "0.875rem",
                                        fontWeight: "600",
                                        color: "#374151",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                    }}
                                >
                                    Price
                                </th>
                                <th
                                    style={{
                                        padding: "1rem",
                                        fontSize: "0.875rem",
                                        fontWeight: "600",
                                        color: "#374151",
                                        textAlign: "right",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                    }}
                                >
                                    Total Bookings
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {classes.slice(0, 5).map((cls, index) => (
                                <tr
                                    key={cls._id}
                                    style={{
                                        borderBottom: index < 4 ? "1px solid #f1f5f9" : "none",
                                        backgroundColor: "#fff",
                                        transition: "all 0.2s ease",
                                        cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#f8fafc"
                                        e.currentTarget.style.transform = "translateY(-1px)"
                                        e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)"
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "#fff"
                                        e.currentTarget.style.transform = "translateY(0)"
                                        e.currentTarget.style.boxShadow = "none"
                                    }}
                                >
                                    <td
                                        style={{
                                            padding: "1rem",
                                            fontSize: "0.875rem",
                                            color: "#374151",
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: "64px",
                                                height: "64px",
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                border: "2px solid #f1f5f9",
                                            }}
                                        >
                                            <img
                                                src={FILE_BASE_URL + "/" + cls.coverPhoto || "/placeholder.svg"}
                                                alt={cls.title}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    transition: "transform 0.2s ease",
                                                }}
                                                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                                                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                                            />
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                            padding: "1rem",
                                            fontSize: "0.875rem",
                                            color: "#374151",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontWeight: 600,
                                                color: "#1f2937",
                                                lineHeight: "1.5",
                                            }}
                                        >
                                            {cls.title}
                                        </span>
                                    </td>
                                    <td
                                        style={{
                                            padding: "1rem",
                                            fontSize: "0.875rem",
                                            color: "#374151",
                                        }}
                                    >
                                        <span
                                            style={{
                                                color: "#059669",
                                                fontWeight: 600,
                                                backgroundColor: "#d1fae5",
                                                padding: "4px 8px",
                                                borderRadius: "6px",
                                                fontSize: "0.8rem",
                                            }}
                                        >
                                            KWD {cls.price}
                                        </span>
                                    </td>
                                    <td
                                        style={{
                                            padding: "1rem",
                                            fontSize: "0.875rem",
                                            color: "#374151",
                                            textAlign: "right",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontWeight: 700,
                                                color: "#1f2937",
                                                fontSize: "1rem",
                                                backgroundColor: "#eff6ff",
                                                padding: "6px 12px",
                                                borderRadius: "8px",
                                                border: "1px solid #dbeafe",
                                            }}
                                        >
                                            {cls.totalBookings}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div
                    style={{
                        padding: "3rem 2rem",
                        border: "2px dashed #d1d5db",
                        borderRadius: "12px",
                        textAlign: "center",
                        backgroundColor: "#f9fafb",
                        color: "#6b7280",
                        fontSize: "1rem",
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "inset 0 2px 4px rgba(0,0,0,0.06)",
                    }}
                >
                    <div
                        style={{
                            fontSize: "3rem",
                            marginBottom: "1rem",
                            color: "#d1d5db",
                        }}
                    >
                        <BookUser color="#33bdbf" />
                    </div>
                    <div style={{ fontWeight: 600, marginBottom: "0.5rem" }}>No classes available</div>
                    <div style={{ fontSize: "0.875rem", color: "#9ca3af" }}>Classes will appear here once added</div>
                </div>
            )}
        </div>
    )
}
